import React, { useContext, useState } from 'react';
import '../App.css'
import moment from 'moment'
import 'moment/locale/pt-br';
import { UserProfile } from '../contexts/UserContext';
import { SystemProfile } from '../contexts/SystemContext';
import Logout from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';
import { Button, Container } from '@mui/material';

import logo from '../assets/logo.png'


const Header = (props) => {
    const [userData, setUserData] = useContext(UserProfile)
    const [systemData, setSystemData] = useContext(SystemProfile)
    const dia = new Date()
    const breadcrumb = props.breadcrumb ? props.breadcrumb : 'Home: / '

    function Logout() {
        setSystemData({...systemData, logged: false})
    }

    return(
        <>
            <div style={styles.top}>
                <Container>
                    <div style={{padding: 9, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <div>
                            Rua Barão do Triunfo, 612 – CJ 901 - São Paulo - SP
                        </div>
                             
                        <div>
                            <button disableElevation variant='text' size='small' style={styles.botoFone}>(11) 5542-4242</button>
                            <button disableElevation variant='text' size='small' style={styles.botoFone}>(11) 98589-3388</button>
                        </div>
                    </div>
                </Container>
            </div>
            <div style={{backgroundColor: '#ee7600', width: '100%', height: 135}}>
                <Container>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'}}>
                        <a href={'https://www.ehsss.com.br'}>
                            <img src={logo} style={{width: 240, height: 135}} />
                        </a>
                        <div style={{marginRight: 55, display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
                            <a href={'https://www.ehsss.com.br'} style={styles.botoBack}>
                                <b>Voltar para o site EHS</b>
                            </a>
                        </div>
                        
                    </div>
                </Container>

            </div>
            
                <Container>
                    {systemData.logged ?
                        <div style={{marginTop: 20, padding: 10, fontSize: 12, fontWeight: 500, color: '#b2b2b2', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-start'}}>
                            <div>
                                <span style={{color: '#949494', fontWeight: 500}}>Olá, {userData.name}</span>
                                {breadcrumb}
                            </div>
                            <Button component={Link} to="/login" style={styles.boto} onClick={()=>{Logout()}}>
                                Sair 
                            </Button>
                        </div>
                    : null}
                </Container>
            
            
        </>
    )
}

export default Header

const styles = {
    boto: {
        backgroundColor: '#ff6400',
        padding: 8,
        borderRadius: 8,
        border: 'none',
        alignItems: 'center',
        justifyContent: 'space-around',
        display: 'flex',
        width: 120,
        color: '#ffffff',
        fontWeight: 600,
        marginBottom: 20
    }, 
    top: {
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center', 
        justifyContent: 'center', 
        backgroundColor: '#4d1f06', 
        paddingLeft: 25,
        paddingRight: 55,
        fontFamily: "Poppins",
        color: '#ffffff',
        fontSize: 12.9,
    },
    botoFone: {
        marginRight: 10,
        marginLeft: 20,
        fontFamily: "Poppins",
        color: '#ffffff',
        fontSize: 13,
        border: 0,
        backgroundColor: 'transparent',
        padding: 0,
        margin: 0,
        textDecoration: 'none',
    },
    botoBack: {
        marginRight: 10,
        fontFamily: "Poppins",
        color: '#ffffff',
        fontSize: 14,
        textDecoration: 'none',
    }
}